module.exports = __webpack_public_path__ + "img/clipboard.27cc6c29.png";